import React, { useState, useEffect } from "react";
import "../../css/components/popups/SessionExpiredModal.css";

const SessionExpiredModal = ({ onRedirect }) => {
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        if (countdown <= 0) {
            onRedirect();
            return;
        }

        const timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [countdown, onRedirect]);

    return (
        <div className="session-expired-overlay">
            <div className="session-expired-card">
                <div className="session-expired-icon">⏰</div>
                <h2>Session Expired</h2>
                <p>Your session has timed out due to inactivity.</p>
                <p className="session-expired-timer">
                    Redirecting to login in <strong>{countdown}</strong> seconds...
                </p>
                <button 
                    className="session-expired-btn" 
                    onClick={onRedirect}
                >
                    Login Now
                </button>
            </div>
        </div>
    );
};

export default SessionExpiredModal;
